/** Public marketing: Plane-inspired hierarchy with Bystep's actual workflows. */
import { m } from '#/paraglide/messages'
import { MkNav, MkFooter } from './mk'
import { RoomSection } from './sections-room'
import { AgentPlatformSection, DesktopSection } from './sections-agents'
import { TeamBuildSection } from './sections-team-build'
import { Hero, AgentsStrip, Proof } from './sections-top'
import { HowItWorks, CliSection, Security, FinalCta } from './sections-bottom'
import {
  LoopSection,
  ControlSection,
  StudioSection,
  PricingSection,
  CompareStrip,
} from './sections-moat'
import {
  ProductExplorer,
  BuildPaths,
  FeatureDirectory,
  PublishSection,
  FaqSection,
} from './sections-platform'

export function LandingPage() {
  return (
    <div className="mk mk-landing h-full overflow-y-auto overflow-x-hidden scroll-smooth">
      <a href="#main-content" className="mk-skip">
        {m.mk_skip()}
      </a>
      <MkNav />
      <main id="main-content" tabIndex={-1}>
        <Hero />
        <AgentsStrip />
        <ProductExplorer />
        <BuildPaths />
        <TeamBuildSection />
        <AgentPlatformSection />
        <HowItWorks />
        <DesktopSection />
        <RoomSection />
        <Proof />
        <LoopSection />
        <ControlSection />
        <FeatureDirectory />
        <StudioSection />
        <PublishSection />
        <CliSection />
        <Security />
        <PricingSection />
        <CompareStrip />
        <FaqSection />
        <FinalCta />
      </main>
      <MkFooter />
    </div>
  )
}
